import { useEffect } from 'react';
import Masonry from '@mui/lab/Masonry';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { includes } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';

import { USER_ROLES } from 'constants/general';
import {
	KCL_DISPLAY_SEMAPHORE,
	MPU_DISPLAY_LEAD_LIST,
	MPU_DISPLAY_LEAD_MARKET,
	MPU_DISPLAY_TASK_LIST,
} from 'features/common/acl/constants';
import { fetchCampaignsSummary } from 'features/views/dashboard/actions';
import { useTitle } from 'features/views/dashboard/hooks';
import { getCurrentRole } from 'features/views/user/selectors';

import Campaigns from './components/Campaigns';
import LeadsOverview from './components/LeadsOverview';
import MarketPlace from './components/MarketPlace';
import Semaphore from './components/Semaphore';
import TasksAndInformation from './components/TasksAndInformation';
import TodaysUrgencies from './components/TodaysUrgencies';

export const MainWidgets = () => {
	const dispatch = useDispatch();
	const title = useTitle();
	const currentRole = useSelector(getCurrentRole);

	useEffect(() => {
		dispatch(fetchCampaignsSummary());
	}, [dispatch]);

	return (
		<Grid container spacing={2} sx={{ zIndex: 2, justifyContent: 'center' }}>
			<Grid size={12}>
				<Typography
					color="white.main"
					variant="h2"
					sx={{
						fontWeight: 'light',
						ml: 2,
					}}
				>
					{title}
				</Typography>
			</Grid>
			<Grid size={12}>
				<TodaysUrgencies />
			</Grid>
			<AccessControl accessLevel={MPU_DISPLAY_LEAD_LIST}>
				<AccessControl accessLevel={MPU_DISPLAY_LEAD_MARKET}>
					<Grid size={12}>
						<MarketPlace />
					</Grid>
				</AccessControl>
			</AccessControl>
			<Grid size={12}>
				<Masonry sx={{ width: 'auto' }} columns={2} spacing={2} sequential>
					<AccessControl accessLevel={MPU_DISPLAY_TASK_LIST}>
						<TasksAndInformation />
					</AccessControl>
					<AccessControl accessLevel={KCL_DISPLAY_SEMAPHORE}>
						<Semaphore />
					</AccessControl>
					<AccessControl accessLevel={MPU_DISPLAY_LEAD_LIST}>
						<LeadsOverview />
					</AccessControl>
					{includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]) && <Campaigns />}
				</Masonry>
			</Grid>
		</Grid>
	);
};

export default MainWidgets;
